import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Papa from 'papaparse';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import CollapsablePanel from 'Common/Components/controlled-collapsable-panel/ControlledCollapsablePanel';
import classes from './CommandButtons.module.css';
import { makeStyles } from 'utils';
import { EXPORT, VIEW_PDF, VIEW_TANDC, CHECK, VALIDATE } from './CommandConstants';

const styles = makeStyles(classes);

const CommandButtonView = ({ checkedCount, viewValidate, handleToggle, onCellClick, getExportData, fileName }) => {
	const link = useRef();
	const handleExport = e => {
		e.stopPropagation();
		e.preventDefault();
		const exportData = getExportData();
		const csv = Papa.unparse(exportData, { header: true });
		const csvUri = encodeURI('data:text/csv;charset=utf-8,' + csv);
		link.current.setAttribute('href', csvUri);
		link.current.click();
	};

	return (
		<>
			<CollapsablePanel open={viewValidate} size="small" onClick={handleToggle}>
				<CollapsablePanel.Closed>
					<div className={styles('container')}>
						<a ref={link} href="data:text/csv,charset=utf-8," download={fileName || true}>
							<Tooltip title={EXPORT} arrow>
								<IconButton name={EXPORT} onClick={handleExport} className={styles('uiButton')}>
									<GetAppIcon />
								</IconButton>
							</Tooltip>
						</a>

						<Tooltip title={VIEW_PDF} arrow>
							<IconButton name={VIEW_PDF} onClick={onCellClick} className={styles('uiButton')}>
								<PictureAsPdfOutlinedIcon />
							</IconButton>
						</Tooltip>

						<Tooltip title={VIEW_TANDC} arrow>
							<IconButton name={VIEW_TANDC} onClick={onCellClick} className={styles('uiButton')}>
								<PictureAsPdfOutlinedIcon />
							</IconButton>
						</Tooltip>

						<Tooltip title={CHECK} arrow>
							<IconButton name={CHECK} onClick={onCellClick} className={styles('uiButton')}>
								<ListAltOutlinedIcon />
							</IconButton>
						</Tooltip>
					</div>
				</CollapsablePanel.Closed>

				<CollapsablePanel.Open>
					<div className={styles('container')}>
						<Tooltip title={VALIDATE} arrow>
							<IconButton name={VALIDATE} onClick={onCellClick}>
								<CloudDoneIcon className={styles('validate')} />
							</IconButton>
						</Tooltip>
					</div>
				</CollapsablePanel.Open>
			</CollapsablePanel>
			<div className={styles('checked-count')}>Checked: {checkedCount}</div>
		</>
	);
};

CommandButtonView.propTypes = {
	checkedCount: PropTypes.number.isRequired,
	viewValidate: PropTypes.bool.isRequired,
	handleToggle: PropTypes.func.isRequired,
	onCellClick: PropTypes.func.isRequired,
	getExportData: PropTypes.func.isRequired,
	fileName: PropTypes.string.isRequired
};

export default CommandButtonView;
